<div class="flex flex-col lg:flex-row justify-between m-0" mat-dialog-title>
  <div class="flex justify-end lg:hidden">
    <mat-icon (click)="onNoClick()">close</mat-icon>
  </div>
  <div class="flex flex-col items-center">
    <h1>{{ data.id ? (('event-types.' + data.type.toString()) | transloco) : 'Nuevo Evento' }}</h1>
    <h3 class="font-normal">{{ data.start | date:'EEEE, d \'de\' MMMM' | titlecase }}</h3>
  </div>
  <div class="flex flex-col lg:flex-row">
    <mat-form-field appearance="fill" class="mr-4">
      <mat-label>Día</mat-label>
      <input (ngModelChange)="changeDay($event)" [matDatepicker]="picker" [ngModel]="data.start" matInput>
      <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="fill" class="mr-4">
      <mat-label>Hora de Inicio</mat-label>
      <input #tInit="matTimepicker" #time1="ngModel" (timeChange)="startHourChange()" [(ngModel)]="data.start"
             matTimepicker
             mode="24h" name="time"
             readonly>
      <mat-icon (click)="tInit.showDialog()" matSuffix>access_time</mat-icon>
      <mat-error *ngIf="time1.touched && time1.invalid">Invalid Date</mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Hora de Fin</mat-label>
      <input #tEnd="matTimepicker" #time2="ngModel" (timeChange)="filterTreatments()" [(ngModel)]="data.end"
             matTimepicker
             mode="24h" name="time"
             readonly>
      <mat-icon (click)="tEnd.showDialog()" matSuffix>access_time</mat-icon>
      <mat-error *ngIf="time2.touched && time2.invalid">Invalid Date</mat-error>
    </mat-form-field>
  </div>

</div>
<div mat-dialog-content>
  <div class="flex flex-col gap-2">
    <div class="w-full mb-4">
      <nav mat-align-tabs="center" mat-tab-nav-bar>
        <button (click)="selectTab(eventType.session)" *ngIf="!isEditMode || data.type === eventType.session"
                [active]="data.type === eventType.session"
                mat-tab-link>
          Sesión
        </button>
        <button (click)="selectTab(eventType.firstInterview)" *ngIf="!isEditMode"
                [active]="data.type === eventType.firstInterview"
                mat-tab-link>
          1ª Entrevista
        </button>
        <button (click)="selectTab(eventType.internalMeeting)" *ngIf="!isEditMode"
                [active]="data.type === eventType.internalMeeting"
                mat-tab-link>
          Evento Interno
        </button>
        <button (click)="selectTab(eventType.other)" *ngIf="!isEditMode" [active]="data.type === eventType.other"
                mat-tab-link>
          Otro
        </button>
        <button (click)="selectTab(eventType.meta)" *ngIf="user.isAdmin" [active]="data.type === eventType.meta"
                mat-tab-link>
          Meta
        </button>
      </nav>
    </div>

    <div *ngIf="(data.type === eventType.internalMeeting || data.type === eventType.other)">

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Título</mat-label>
        <input [(ngModel)]="data.title" matInput/>
      </mat-form-field>

    </div>

    <div *ngIf="data.type !== eventType.firstInterview && !isEditMode"
         class="flex flex-col lg:flex-row justify-between">

      <div class="flex flex-col">

        <p class="text-xl mb-4">Es una sesión peródica?</p>

        <div class="mb-4">
          <mat-radio-group [(ngModel)]="calendarType" class="w-full">
            <mat-radio-button [value]="1" class="mr-4">Periódico</mat-radio-button>
            <mat-radio-button [value]="2" class="mr-4">Puntual</mat-radio-button>
            <mat-radio-button [value]="3" class="mr-4">Pack 3 meses</mat-radio-button>
          </mat-radio-group>
        </div>

      </div>

      <div class="flex flex-col justify-center">
        <mat-button-toggle-group
          *ngIf="calendarType === 1 || calendarType === 3"
          [(ngModel)]="daySelected" class="mb-4 flex justify-around" multiple>
          <mat-button-toggle value="1">L</mat-button-toggle>
          <mat-button-toggle value="2">M</mat-button-toggle>
          <mat-button-toggle value="3">X</mat-button-toggle>
          <mat-button-toggle value="4">J</mat-button-toggle>
          <mat-button-toggle value="5">V</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
    <div *ngIf="data.type !== eventType.firstInterview && !isEditMode && calendarType === 1"
         class="flex flex-col">

      <p class="text-xl mb-4">Periodicidad?</p>

      <div class="mb-4">
        <mat-radio-group [(ngModel)]="periodicity" class="w-full">
          <mat-radio-button [value]="1" class="mr-4">Cada semana</mat-radio-button>
          <mat-radio-button [value]="2" class="mr-4">Cada 2 semanas</mat-radio-button>
        </mat-radio-group>
      </div>

    </div>

    <div class="flex items-center" *ngIf="data.type === eventType.session || data.type === eventType.other">
      <app-form-field-client-select class="w-full" [control]="clientSelected"></app-form-field-client-select>
      <ng-container *ngIf="clientSelected?.value?.id">
        <a target="_blank" routerLink="/clientes/{{ clientSelected?.value?.id }}" class="text-blue-500 underline">
          <mat-icon svgIcon="chevron_right"></mat-icon>
        </a>
      </ng-container>
    </div>
    <div *ngIf="data.type !== eventType.meta">
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Profesional</mat-label>
        <mat-select (valueChange)="onUserChange($event)" [(ngModel)]="data.usersId" [disabled]="!user?.isAdmin"
                    multiple>
          <mat-option *ngFor="let user of users" [value]="user.id">
            {{ user.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div *ngIf="data.type === eventType.session">
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Tipo de tratamiento</mat-label>
        <mat-select [(ngModel)]="data.treatmentId" [disabled]="!user?.isAdmin">
          <mat-option *ngFor="let treatment of treatmentsFiltered" [value]="treatment.id">
            {{ treatment.name }}{{ treatment.bonus ? ' con Bono' : '' }}, {{ treatment.duration }} minutos
            a {{ treatment.pricing }}€
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div *ngIf="data.type === eventType.firstInterview || data.type === eventType.other" class="mb-4 flex flex-col">

    <div *ngIf="!isEditMode" class="flex flex-col">
      <!--      <p class="text-xl my-4 flex items-center gap-2">-->
      <!--        <span>Vinculada a una tarjeta</span>-->
      <!--        <mat-icon (click)="showNewCardElements()" svgIcon="add_circle"></mat-icon>-->
      <!--      </p>-->
      <div class="grid grid-cols-3 gap-2">
        <mat-form-field *ngIf="firstInterviewBoardSelected" appearance="fill" class="w-full">
          <mat-label>Lista</mat-label>
          <mat-select [(ngModel)]="firstInterviewListSelected" [disabled]="!user?.isAdmin">
            <mat-option *ngFor="let list of firstInterviewBoardSelected?.lists; let index = index" [value]="index">
              {{ list.title }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          *ngIf="(firstInterviewListSelected || firstInterviewListSelected === 0) && firstInterviewListSelected >= 0"
          appearance="fill"
          class="w-full">
          <mat-label>Tarjeta</mat-label>
          <mat-select [(ngModel)]="firstInterviewCardSelected">
            <mat-option *ngFor="let card of firstInterviewBoardSelected?.lists[firstInterviewListSelected]?.cards"
                        [value]="card">
              {{ card.title }}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>
    </div>


    <div *ngIf="isEditMode && data.boardCard" class="mt-8">
      <div class="text-bold text-2xl flex items-center mb-6">
        <mat-icon class="mr-6" svgIcon="mat_outline:notes"></mat-icon>
        <div class="flex items-center gap-4">
          <span>{{ firstInterviewBoardSelected?.lists[firstInterviewListSelected]?.title }}</span>
          <mat-icon svgIcon="mat_outline:double_arrow"></mat-icon>
          <span>{{ firstInterviewCardSelected?.title }} ({{ firstInterviewCardSelected?.phone }})</span>
        </div>
      </div>

      <div class="bg-gray-100 rounded-2xl p-6 mb-6">
        <p [innerHTML]="firstInterviewCardSelected?.description" class="whitespace-pre-line"></p>
        <!--        <div class="flex justify-end text-slate-500 items-center italic text-sm">-->
        <!--          <span>{{ act.createDate | momentTimestampDate:'HH:mm \'del\' dd/MM/yyyy' }}</span>-->
        <!--        </div>-->
      </div>

      <div class="flex justify-center">
        <a (click)="onNoClick()"
           *ngIf="!firstInterviewCardSelected?.interview"
           [routerLink]="'primeras-entrevistas/'
         + firstInterviewCardSelected?.boardId
         + '/' + firstInterviewCardSelected?.id"
           color="primary"
           mat-raised-button>
          Realizar 1ª Entrevista
        </a>
      </div>
      <a (click)="onNoClick()"
         *ngIf="firstInterviewCardSelected?.interview"
         [routerLink]="'primeras-entrevistas/'
         + firstInterviewCardSelected?.boardId
         + '/' + firstInterviewCardSelected?.id"
         mat-raised-button>
        Ver 1ª Entrevista
      </a>

    </div>
  </div>

  <div *ngIf="data.type === eventType.session && isEditMode && !isCancelled && user?.isAdmin"
       class="flex justify-center">
    <button (click)="cancelEvent()" color="warn" mat-raised-button>Cancelar Sesión</button>
  </div>


  <div *ngIf="data.type === eventType.meta">
    <form [formGroup]="metaForm" class="flex flex-col">
      <div class="flex mb-4">
        <p class="w-[150px] flex items-center">Está pagada</p>
        <mat-button-toggle-group formControlName="isPaid" name="isPaid">
          <mat-button-toggle [value]="true">Si</mat-button-toggle>
          <mat-button-toggle [value]="false">No</mat-button-toggle>
          <mat-button-toggle [value]="null">Sin valor</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div class="flex mb-4">
        <p class="w-[150px] flex items-center">Está recuperada</p>
        <mat-button-toggle-group formControlName="isRecovered" name="isRecovered">
          <mat-button-toggle [value]="true">Si</mat-button-toggle>
          <mat-button-toggle [value]="false">No</mat-button-toggle>
          <mat-button-toggle [value]="null">Sin valor</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div class="flex mb-4">
        <p class="w-[150px] flex items-center">Es una recuperación</p>
        <mat-button-toggle-group formControlName="isRecovery" name="isRecovery">
          <mat-button-toggle [value]="true">Si</mat-button-toggle>
          <mat-button-toggle [value]="false">No</mat-button-toggle>
          <mat-button-toggle [value]="null">Sin valor</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div *ngIf="isCancelled" class="flex flex-col mb-4">
        <p class="w-[150px] flex items-center">Está cancelada</p>
        <p>Tipo de Cancelación: {{ ('event-cancellation-type.' + data.cancellationType) | transloco }}</p>
        <p>Subtipo de Cancelación: {{ ('event-cancellation-subtype.' + data.cancellationSubType) | transloco }}</p>
        <p>Razón de Cancelación: {{ data.cancellationReason }}</p>

      </div>

      <div class="flex justify-end">
        <button (click)="saveMeta()" class="text-white" color="accent" mat-raised-button>Guardar</button>
      </div>
    </form>
  </div>


</div>

<div *ngIf="data.type !== eventType.meta">
  <div *ngIf="!isEditMode && user?.isAdmin" class="flex justify-between" mat-dialog-actions>
    <button (click)="onNoClick()" mat-raised-button>Cancelar</button>
    <button (click)="createEvent()" [disabled]="clientSelected?.invalid || !time2.value" class="text-white"
            color="primary"
            mat-raised-button>Crear Evento
    </button>
  </div>

  <div *ngIf="isEditMode && !isCancelled && user?.isAdmin" class="flex justify-between" mat-dialog-actions>
    <button (click)="onNoClick()"
            mat-raised-button>Cancelar
    </button>
    <div>
      <button (click)="delete()" class="text-white" color="warn"
              mat-raised-button>Borrar
      </button>
      <button (click)="edit()" class="text-white" color="accent"
              mat-raised-button>Editar
      </button>
    </div>
  </div>
  <div *ngIf="isEditMode && isCancelled && user?.isAdmin" class="flex justify-between" mat-dialog-actions>
    <button (click)="onNoClick()"
            mat-raised-button>Cancelar
    </button>
    <div>
      <button (click)="setNoRecovery()"
              mat-raised-button>No recuperar sesión
      </button>
      <button (click)="restoreEvent()" class="text-white" color="accent"
              mat-raised-button>Restaurar Sesión
      </button>
      <button (click)="recoveryEvent()" class="text-white" color="primary"
              mat-raised-button>Crear Recuperación
      </button>
    </div>
  </div>
</div>
